<link
  href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap"
  rel="stylesheet"
/>

<div class="grid grid-cols-12 h-[100%]">
  <div class="col-span-12">
    <form
      (keydown)="preventSubmit($event)"
      [formGroup]="form"
      class="h-[100%] flex flex-col justify-between"
    >
      <div class="sticky !bg-[#fff] top-0 !p-0">
        <div class="flex justify- items-center gap-8 top-0 !bg-[#dee2e6] p-4">
          <div
            class="flex justify-start items-center gap-8 top-0 !bg-[#dee2e6]"
          >
            <h3 class="project-brief">Project Brief</h3>
            <span
              class="!ml-[10px] bg-[#F4F4F4] px-[20px] rounded-[0.625rem] text-[#343A40] roboto font-semibold"
              >Budget and Timeline</span
            >
          </div>
          <!-- Close Icon -->
          <div
            style="position: absolute; top: 10px; right: 36px; z-index: 50"
            (click)="closeDialog()"
          >
            <img
              src="assets/icons/cross-icon.svg"
              alt="cross icon"
              class="cursor-pointer !fixed"
            />
          </div>
        </div>
        <div class="flex justify-end">
          <app-progress-bar
            [progress]="stage1Progress"
            [sectionId]="'section1'"
            [selectedSection]="selectedSection"
            [sectionName]="'Project Brief'"
          >
          </app-progress-bar>
        </div>
      </div>
      <div id="section-project-grade" class="mb-8">
        <div class="pt-[6px] pr-6 pb-6 pl-6 mx-[10px] w-[91%]">
          <app-grade
            (contentChange)="addGrade($event)"
            [grade]="grade"
            [selectedGrade]="selectedGradeName"
          ></app-grade>

          <div id="section-project-budget" class="h-[65px] flex">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Enter Allocated Budget Amount</mat-label>
              <input
                matInput
                maxlength="12"
                formControlName="allocated"
                id="allocated"
                currencyMask
                [options]="{
                  prefix: country?.symbol ? country?.symbol : '$',
                  suffix: '',
                  thousands: ',',
                  allowZero: false,
                  decimal: '',
                  precision: 0,
                  nullable: true,
                  align: 'right',
                  max: 100000000000,
                }"
                class=""
                placeholder=" "
              />
            </mat-form-field>
          </div>

          <sub
            *ngIf="form.get('allocated').value"
            id="section-project-budget-in-words"
            class="flex mb-4"
            style="line-height: 12px"
          >
            <label for="allocated" class="mt-[10px] section-label-sm"
              >(Amount In Words)
            </label>
            <div
              class="flex justify-start ml-[9px] mt-[10px] w-[294px] overflow-wrap break-words"
            >
              <div class="ml-[5px] flex items-center justify-center">
                <p id="amountInWords" class="!m-0">
                  {{ amountInWords }}
                </p>
              </div>
            </div>
          </sub>

          <div class="flex items-center">
            <label
              for="checkbox"
              class="section-label-sm font-semibold mr-[16px] mt-[10px]"
              >GMP</label
            >
            <input
              type="checkbox"
              formControlName="showGMPFields"
              class="customized-checkbox"
              [disabled]="form.get('allocated')?.value === null"
            />
          </div>
          <div class="flex justify-between">
            <div>
              <div
                *ngIf="form.get('showGMPFields')?.value"
                class="mt-4 h-[60px] flex"
              >
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Enter Risk & Contingency Budget</mat-label>
                  <input
                    matInput
                    formControlName="rcbudget"
                    id="rcbudget"
                    currencyMask
                    [options]="{
                      prefix: country?.symbol ? country?.symbol : '$',
                      thousands: ',',
                      decimal: '',
                      nullable: true,
                      allowZero: false,
                      precision: 0,
                      max: 100000000000,
                    }"
                    placeholder=" "
                  />
                </mat-form-field>
              </div>
              <sub
                *ngIf="form.get('rcbudget').value"
                id="rcbudget-budget-in-words"
                class="flex mb-4 w-[440px]"
                style="line-height: 12px"
              >
                <div
                  class="flex justify-start ml-[9px] mt-[10px] overflow-wrap break-words"
                >
                  <div class="ml-[5px] flex items-center justify-center">
                    <p id="rcamountInWords" class="!m-0">
                      {{ RCamountInWords }}
                    </p>
                  </div>
                </div>
              </sub>
              <!-- <div
                *ngIf="form.get('showGMPFields')?.value"
                class=" mt-[15px] w-[294px] overflow-wrap break-words"
              >
                <p>{{ RCamountInWords }}</p>
              </div> -->
            </div>
            <div>
              <div *ngIf="form.get('showGMPFields')?.value" class="mt-4 flex">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Enter GMP Budget</mat-label>
                  <input
                    matInput
                    formControlName="capbudget"
                    id="capbudget"
                    [readonly]="true"
                    currencyMask
                    [options]="{
                      prefix: country?.symbol ? country?.symbol : '$',
                      thousands: ',',
                      decimal: '',
                      precision: 0,
                      allowZero: false,
                      max: 100000000000,
                    }"
                    placeholder=" "
                  />
                </mat-form-field>
              </div>

              <sub
                class="mb-4 flex"
                style="line-height: 12px"
                *ngIf="
                  form.get('showGMPFields')?.value &&
                  form.get('capbudget').value
                "
                id="section-project-cap-budget-in-words "
              >
                <label for="allocated" class="section-label-sm mt-[10px]"
                  >(Amount In Words)
                </label>

                <div
                  class="flex justify-start mt-[10px] overflow-wrap break-words w-[294px] ml-[9px]"
                >
                  <div class="ml-[5px] flex justify-center items-center">
                    <p id="gmpamountInWords" class="!m-0">
                      {{ gmpAmountInWords }}
                    </p>
                  </div>
                </div>
              </sub>
            </div>
          </div>

          <!-- TODO: here after need to be converted in mat-form -->
          <div class="mb-[25px] mt-5">
            <div class="">
              <div class="flex justify-between">
                <div id="section-project-dates" class="h-[65px] flex">
                  <mat-form-field class="!w-[100%]" appearance="outline">
                    <mat-label> Project Start Date </mat-label>
                    <input
                      matInput
                      [matDatepicker]="startDate"
                      formControlName="projectStartDate"
                      placeholder="MM/DD/YYYY"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="startDate"
                    ></mat-datepicker-toggle>
                    <mat-datepicker
                      #startDate
                      startView="year"
                    ></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="h-[65px] flex">
                  <mat-form-field class="!w-[100%]" appearance="outline">
                    <mat-label> Project End Date </mat-label>
                    <input
                      matInput
                      [matDatepicker]="endDate"
                      formControlName="projectEndDate"
                      placeholder="MM/DD/YYYY"
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="endDate"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #endDate startView="year"></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <div
                id="section-project-milestones"
                class="mb-4 flex items-center"
              >
                <label
                  for="mileStonesCheck"
                  class="section-label-sm font-semibold mr-[16px] mt-[10px]"
                >
                  Milestone
                </label>
                <input
                  [disabled]="
                    !(
                      form.get('projectStartDate').value &&
                      form.get('projectEndDate').value
                    )
                  "
                  type="checkbox"
                  formControlName="mileStonesCheck"
                  class="customized-checkbox"
                />
              </div>

              <div
                *ngIf="showMileStonesField"
                formGroupName="mileStonesData"
                class="container !w-[70vw]"
              >
                <!-- Loop through mileStonesGroups (FormArray) -->
                <div
                  *ngFor="
                    let mileStone of mileStonesGroups.controls;
                    let i = index
                  "
                  [formGroupName]="i.toString()"
                  class="mileStone-row"
                >
                  <!-- Milestone Form Fields Section -->
                  <div class="mileStones-section mileStoneSection-height">
                    <div class="relative flex items-center">
                      <mat-form-field class="!w-[100%]" appearance="outline">
                        <mat-label> Milestone </mat-label>
                        <input
                          matInput
                          formControlName="name"
                          placeholder="Milestone"
                        />
                      </mat-form-field>
                    </div>

                    <div
                      class="flex justify-start items-center gap-[16px] mileStoneSection-dates"
                    >
                      <div class="relative flex items-center">
                        <mat-form-field appearance="outline" class="">
                          <mat-label>Start Date</mat-label>
                          <input
                            matInput
                            [matDatepicker]="milestoneStartDate"
                            type="text"
                            formControlName="start_date"
                            [min]="
                              dateFormatter(form.get('projectStartDate').value)
                            "
                            [max]="
                              dateFormatter(form.get('projectEndDate')?.value)
                            "
                            placeholder="MM/DD/YYYY"
                          />
                          <mat-datepicker-toggle
                            matIconSuffix
                            [for]="milestoneStartDate"
                          ></mat-datepicker-toggle>
                          <mat-datepicker
                            #milestoneStartDate
                            startView="year"
                          ></mat-datepicker>
                        </mat-form-field>
                      </div>

                      <div class="relative flex items-center mr-[15px]">
                        <mat-form-field appearance="outline" class="">
                          <mat-label>End Date</mat-label>
                          <input
                            matInput
                            [matDatepicker]="milestoneEndDate"
                            type="text"
                            formControlName="end_date"
                            placeholder="MM/DD/YYYY"
                            [min]="
                              dateFormatter(form.get('projectStartDate').value)
                            "
                            [max]="
                              dateFormatter(form.get('projectEndDate')?.value)
                            "
                          />
                          <mat-datepicker-toggle
                            matIconSuffix
                            [for]="milestoneEndDate"
                          ></mat-datepicker-toggle>
                          <mat-datepicker
                            #milestoneEndDate
                            startView="year"
                            [startAt]="
                              dateFormatter(form.get('projectStartDate').value)
                            "
                          >
                          </mat-datepicker>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="flex mb-[20px]">
                    <!-- Delete Button -->
                    <button
                      type="button"
                      mat-button
                      class="square-button border !border-[#E76B3F] mr-3"
                      (click)="removeQualityForm(i)"
                      *ngIf="mileStonesGroups?.length > 1"
                    >
                      <mat-icon class="!bg-[#EFF8FF] !text-[#E76B3F] !pt-[1px]"
                        >remove</mat-icon
                      >
                    </button>

                    <!-- Add Button -->
                    <button
                      type="button"
                      mat-button
                      class="square-button"
                      (click)="addQualityForm()"
                      *ngIf="i === mileStonesGroups.length - 1"
                    >
                      <mat-icon class="!bg-[#EFF8FF] !text-[#E76B3F] !pt-[1px]"
                        >add</mat-icon
                      >
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <app-stakeholder
            id="section-project-stakeholders"
            (contentChange)="addStakeHolder($event)"
            (removeContent)="removeStakeholder($event)"
            [selectedStakeholders]="selectedStakeholders"
          ></app-stakeholder>
        </div>
      </div>

      <!-- Buttons -->
      <div class="flex justify-between sticky p-6 mx-[10px]">
        <div class="flex items-center">
          <button
            mat-button
            type="button"
            class="bg-[#e76b3f] text-[16px] rounded-[0.1875rem] text-white w-[180px] h-[48px]"
            (click)="handleProjectStage1Approval()"
            [ngClass]="
              approvalDetails.length > 0 &&
              approvalDetails[0].parentStatus !== 'pending'
                ? '!bg-[#197741] !border-[#197741]'
                : ''
            "
          >
            <span>{{
              isStageOneSendForApproval
                ? "Approval Status"
                : "Send For Approval"
            }}</span>
          </button>
        </div>

        <!-- Right side buttons -->
        <div class="w-[100%] flex justify-end mb-[1rem] mt-[21px]">
          <button
            (click)="handleBack()"
            type="button"
            class="save-btn !mr-[10px] !bg-[#fff]"
          >
            Back
          </button>
          <button
            class="save-btn shadow-[0px_4px_4px_rgba(0,0,0,0.25)] !font-medium"
            type="button"
            (click)="handleSubmit('save')"
          >
            <ng-container *ngIf="isLoadingSave; else normalTextSave">
              <div class="spinner"></div>
            </ng-container>
            <ng-template #normalTextSave>Save</ng-template>
          </button>
          <button
            class="next-btn"
            type="button"
            (click)="handleSubmit('next')"
            [ngClass]="{ 'loading-btn': isLoadingNext }"
          >
            <ng-container *ngIf="isLoadingNext; else normalTextNext">
              <div class="spinner"></div>
            </ng-container>
            <ng-template #normalTextNext>Save & Close</ng-template>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
